import { MessageContentType } from '../../BotMessage.constants';
import {
  isActionStepContentProps,
  isActionStepGroupContentProps,
  isConfirmActionContentProps,
  isGuidelineExpanderCardContentProps,
  isListContentProps,
  isTextContentProps,
} from '../../BotMessage.utils';

import ActionStepContent from './ActionStepContent';
import ActionStepGroupContent from './ActionStepGroupContent';
import ConfirmActionContent from './ConfirmActionContent';
import GuidelineExpanderCardContent from './GuidelineExpanderCardContent';
import ListContent from './ListContent';
import TextContent from './TextContent';

export const contentTypeGuardMap = {
  [MessageContentType.TEXT]: isTextContentProps,
  [MessageContentType.CONFIRM_ACTION]: isConfirmActionContentProps,
  [MessageContentType.LIST]: isListContentProps,
  [MessageContentType.ACTION_STEP]: isActionStepContentProps,
  [MessageContentType.ACTION_STEP_GROUP]: isActionStepGroupContentProps,
  [MessageContentType.GUIDELINE_EXPANDER_CARD]: isGuidelineExpanderCardContentProps,
};

export const contentComponentMap = {
  [MessageContentType.TEXT]: TextContent,
  [MessageContentType.CONFIRM_ACTION]: ConfirmActionContent,
  [MessageContentType.LIST]: ListContent,
  [MessageContentType.ACTION_STEP]: ActionStepContent,
  [MessageContentType.ACTION_STEP_GROUP]: ActionStepGroupContent,
  [MessageContentType.GUIDELINE_EXPANDER_CARD]: GuidelineExpanderCardContent,
};
